// extracted by mini-css-extract-plugin
export default {"container":"Error_container__BMUeQ","error":"Error_error__8jFT4","icon":"Error_icon__uXpy9"};